// extracted by mini-css-extract-plugin
export var add = "styles-module__add___eRj7P";
export var badge = "styles-module__badge___pRsV8";
export var bookmarkButton = "styles-module__bookmarkButton___i02g1";
export var bottomButtons = "styles-module__bottomButtons___InFPg";
export var container = "styles-module__container___wKw9v";
export var content = "styles-module__content___RK1eC";
export var contentContainer = "styles-module__contentContainer___DSwb_";
export var fullWidth = "styles-module__fullWidth___o4cRr";
export var image = "styles-module__image___inJo5";
export var userImage = "styles-module__userImage___k4B8r";